import { Form } from '@ui';
import styled from 'styled-components';

export const SectionSC = styled(Form.Section)`
  .checkbox-wrapper {
    display: grid;
    justify-items: start;

    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 0 0;
    grid-template-areas:
      '. . '
      '. . ';

    max-height: 225px;

    .services-checkbox {
      margin-left: 16px;
    }
  }
`;
